<template>
    <router-link :to="'article/' + slug" class="card">
        <img :src="articleData.thumbnail" alt="">
        {{ articleData.title }}
    </router-link>
</template>

<script>
    export default {
        name: "ArticleCard",
        props: ["slug", "articleData"],
    }
</script>

<style scoped>
    .card {
        position: absolute;

        width: 50vw;
        height: 50vh;

        background: white;
        border-radius: 5px;

        cursor: pointer;

        display: flex;
        justify-content: center;
        align-items: center;

        padding: 8px;
        text-decoration: none;
        text-align: center;
        color:  #333333;

        transform: translateZ(-50vh);
        transition: transform 1s;

        font-size: 24px;
    }

    img {
        max-height: 50vh;
        max-width: 50vw;
    }

    @media screen and (orientation: portrait) {
        .card {
            flex-direction: column;
            justify-content: space-evenly;
        }
    }

    .next {
        z-index: 100;
        box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
        transform: translateZ(0);
    }

    .removed {
        transform: translateY(-80vh) rotateX(90deg);
        box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
        z-index: 100;
    }
</style>